import React from "react";
import Layout from "./layout.js";
import Breadcrumbs from "../component/Breadcrumbs.js";
import SectionHeading from "../component/SectionHeading.js";
// import IconCard from "../component/IconCard.js";
// import turnAroundIcon from "../assets/images/turn-around.svg";
// import investmentIcon from "../assets/images/investment.svg";
// import maStrategyIcon from "../assets/images/ma-strategy.svg";
// import esgStrategyIcon from "../assets/images/esg-strategy.svg";
// import strategicAgendaIcon from "../assets/images/strategic-agenda.svg";
// import marketSizingIcon from "../assets/images/market-sizing.svg";
// import voiceOfCustomerIcon from "../assets/images/voice-of-customer.svg";
// import competitiveAnalysisIcon from "../assets/images/competitive-analysis.svg";
// import benchmarkingIcon from "../assets/images/benchmarking.svg";
// import macroEnviromentIcon from "../assets/images/macro-enviroment.svg";
// import valueRiskIcon from "../assets/images/value-risk.svg";
// import strategicDueIcon from "../assets/images/strategic-due.svg";
// import synergyAnalysisIcon from "../assets/images/synergy-analysis.svg";
// import marketAssessmentIcon from "../assets/images/market-assessment.svg";
import org_casestudy1_img1 from "../assets/images/org_casestudy1_img1.png";
import org_casestudy1_img2 from "../assets/images/org_casestudy1_img2.png";
import org_casestudy1_img3 from "../assets/images/org_casestudy1_img3.png";
import org_casestudy2_img1 from "../assets/images/org_casestudy2_img1.png";
import org_casestudy2_img2 from "../assets/images/org_casestudy2_img2.png";
import org_casestudy2_img3 from "../assets/images/org_casestudy2_img3.png";
import org_casestudy3_img1 from "../assets/images/org_casestudy3_img1.png";
import org_casestudy3_img2 from "../assets/images/org_casestudy3_img2.png";
import org_casestudy3_img3 from "../assets/images/org_casestudy3_img3.png";
import org_casestudy4_img1 from "../assets/images/org_casestudy4_img1.png";
import org_casestudy4_img2 from "../assets/images/org_casestudy4_img2.png";
import org_casestudy4_img3 from "../assets/images/org_casestudy4_img3.png";
import Fancybox from "../assets/js/fancybox.js";

export default function OrgTransformationChangeManagement({pageName}) {

  return (
    <Layout pageName={pageName}>
      <Breadcrumbs title="Services" text={pageName} />

      {/* <section className="consult-outcome-sec sec-padding">
        <div className="container">
          <SectionHeading headingClassName="full-text" secName="Consulting Outcomes" secText="We deliver end-to-end consulting outcomes…" />

          <div className="card-row row justify-content-center">
            <IconCard lg="3" md="4" col="6" className="border-card" icon={synergyAnalysisIcon} title="Org. restructuring strategy"/>
            <IconCard lg="3" md="4" col="6" className="border-card" icon={marketSizingIcon} title="Post-Merger integration plan"/>
            <IconCard lg="3" md="4" col="6" className="border-card" icon={voiceOfCustomerIcon} title="Talent management strategy"/>
            <IconCard lg="3" md="4" col="6" className="border-card" icon={maStrategyIcon} title="Reward Recognition Plan"/>
            <IconCard lg="3" md="4" col="6" className="border-card" icon={benchmarkingIcon} title="Succession Plan"/>
            <IconCard lg="3" md="4" col="6" className="border-card" icon={valueRiskIcon} title="Change Readiness"/>
            <IconCard lg="3" md="4" col="6" className="border-card" icon={macroEnviromentIcon} title="Change Adoption Plan"/>
            <IconCard lg="3" md="4" col="6" className="border-card" icon={esgStrategyIcon} title="Leadership Development Program"/>
            <IconCard lg="3" md="4" col="6" className="border-card" icon={investmentIcon} title="Risk Management Plan"/>
          </div>
        </div>
      </section>

      <section className="project-input-sec sec-padding">
        <div className="container">
          <SectionHeading headingClassName="full-text" secName="Project Inputs" secText="…and also support you with the foundational project inputs that form the backbone of these outcomes:" />

          <div className="card-row row justify-content-center">
            <IconCard lg="3" md="4" col="6" className="trans-card" icon={strategicAgendaIcon} title="Climate Survey"/>
            <IconCard lg="3" md="4" col="6" className="trans-card" icon={benchmarkingIcon} title="Customer satisfaction study"/>
            <IconCard lg="3" md="4" col="6" className="trans-card" icon={maStrategyIcon} title="M&A cultural fit assessment"/>
            <IconCard lg="3" md="4" col="6" className="trans-card" icon={esgStrategyIcon} title="Leadership effectiveness assessment"/>
            <IconCard lg="3" md="4" col="6" className="trans-card" icon={competitiveAnalysisIcon} title="Competence and Capacity assessment"/>
            <IconCard lg="3" md="4" col="6" className="trans-card" icon={strategicDueIcon} title="Change readiness assessment"/>
            <IconCard lg="3" md="4" col="6" className="trans-card" icon={valueRiskIcon} title="Change Impact assessment"/>
            <IconCard lg="3" md="4" col="6" className="trans-card" icon={turnAroundIcon} title="L&D Framework design"/>
          </div>
        </div>
      </section> */}

       {/* 01 */}

      <section className="case-study sec-padding">
        <div className="container">
          <SectionHeading secName="Case study" secText={<>Organisation Transformation (Transforming Culture through Values)</>} />

          <div className="row case-study-row">
            <div className="col-lg-6">
              <div className="case-study-card">
                <h5 className="title">Project Stakeholders</h5>
                <ul className="content">
                  <li className="p-text">The client is a budding travel-tech organization which was aspiring to get listed in India.</li>
                </ul>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="case-study-card">
                <h5 className="title">Project Scope</h5>
                <ul className="content">
                  <li className="p-text">Define the desired organizational culture and take structured steps to embed it across the company</li>
                  <li className="p-text">Work with the leadership team to imbibe the new culture and live the values</li>
                </ul>
              </div>
            </div>

            <div className="col-lg-12">
              <div className="case-study-card">
                <h5 className="title">Approach and Execution</h5>
                <ul className="content">
                  <li className="p-text">We co-created the values using a storytelling approach, cascaded them across the organisation, and integrated the values into the HR processes</li>
                  <li className="p-text">Leadership development was aligned with the leadership behaviours necessary for the desired culture. A six month developmental journey was undertaken</li>
                  
                </ul>
              </div>
            </div>

            <div className="col-lg-12">
              <div className="case-study-card">
                <h5 className="title">Key Project Deliverables</h5>
                <ul className="content">
                  <li className="p-text"><b>Impact:</b> The culture continues to be a strength of the company, helping in the attraction and retention of top talent globally. The values have been firmly entrenched in the organisation</li>
                </ul>
                <div className="content key-project-content">

                <Fancybox options={{Carousel: {infinite: false,},}}>
                  <div className="row case-study-row justify-content-center">
                    <div className="col-lg-6">
                      <div className="inner-card">
                        <div className="img-div"><img src={org_casestudy1_img1} alt="operationalService5" className="img" /></div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="inner-card">
                        <div className="img-div"><img src={org_casestudy1_img2} alt="operationalService6" className="img" /></div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="inner-card">
                        <div className="img-div"><img src={org_casestudy1_img3} alt="operationalService7" className="img" /></div>
                      </div>
                    </div>
                  </div>
                </Fancybox>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      {/* 02 */}
      <section className="case-study sec-padding">
        <div className="container">
          <SectionHeading secName="Case study" secText={<>Organisation Transformation (Architecting Agility through Organisational Design)</>} />

          <div className="row case-study-row">
            <div className="col-lg-6">
              <div className="case-study-card">
                <h5 className="title">Project Stakeholders</h5>
                <ul className="content">
                  <li className="p-text">The client is a prominent fashion retail brand</li>
                </ul>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="case-study-card">
                <h5 className="title">Project Scope</h5>
                <ul className="content">
                  <li className="p-text">Aiming to align its structure to execute the new strategy effectively</li>
                  <li className="p-text">To drive agility within the organisation through effective organisation design</li>
                </ul>
              </div>
            </div>

            <div className="col-lg-12">
              <div className="case-study-card">
                <h5 className="title">Approach and Execution</h5>
                <ul className="content">
                  <li className="p-text">We conducted discovery dialogues using the appreciative inquiry framework to define the design principles. Spans and layers were analyzed, and productivity numbers were benchmarked</li>
                  <li className="p-text">Spans and Layers were analysed and an optimization plan created</li>
                  <li className="p-text">A new organisation design was created jointly</li>
                  <li className="p-text">Functional workshops helped people define their role’s purpose and create role charters. The RACI matrix brought in accountability. Career paths were defined and transparently shared</li>
                </ul>
              </div>
            </div>

            <div className="col-lg-12">
              <div className="case-study-card">
                <h5 className="title">Key Project Deliverables</h5>
                <ul className="content">
                  <li className="p-text"><b>Impact:</b> The collaborative approach contributed significantly to adopting the new organization design. The structure, in turn, helped reduce costs, increase agility, and play a significant role in strategy implementation</li>
                </ul>
                <div className="content key-project-content">

                <Fancybox options={{Carousel: {infinite: false,},}}>
                  <div className="row case-study-row justify-content-center">
                    <div className="col-lg-6">
                      <div className="inner-card">
                        <div className="img-div"><img src={org_casestudy2_img1} alt="operationalService5" className="img" /></div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="inner-card">
                        <div className="img-div"><img src={org_casestudy2_img2} alt="operationalService6" className="img" /></div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="inner-card">
                        <div className="img-div"><img src={org_casestudy2_img3} alt="operationalService7" className="img" /></div>
                      </div>
                    </div>
                  </div>
                </Fancybox>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>



      
      {/* 03 */}
      <section className="case-study sec-padding">
        <div className="container">
          <SectionHeading secName="Case study" secText={<>Organisation Transformation (Building Organisation Health)</>} />

          <div className="row case-study-row">
            <div className="col-lg-6">
              <div className="case-study-card">
                <h5 className="title">Project Stakeholders</h5>
                <ul className="content">
                  <li className="p-text">The client is a family-run consumer-facing company</li>
                </ul>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="case-study-card">
                <h5 className="title">Project Scope</h5>
                <ul className="content">
                  <li className="p-text">Assess the organization’s health to control attrition and improve employee morale</li>
                  <li className="p-text">Overall part of cultural transformation agenda</li>
                </ul>
              </div>
            </div>

            <div className="col-lg-12">
              <div className="case-study-card">
                <h5 className="title">Approach and Execution</h5>
                <ul className="content">
                  <li className="p-text">We designed an engagement survey and administered it across the organisation. The results were evaluated under multiple categories, and the qualitative comments were analyzed</li>
                  <li className="p-text">Organization-wide action plans were defined, along with specific functional plans. The survey process was institutionalized as a bi-annual event</li>
                  <li className="p-text">Issued related to women, Senior Management were identified and acted upon</li>
                </ul>
              </div>
            </div>

            <div className="col-lg-12">
              <div className="case-study-card">
                <h5 className="title">Key Project Deliverables</h5>
                <ul className="content">
                  <li className="p-text"><b>Impact:</b> The company has shown a steady increase in engagement, positively impacting its performance and reducing attrition. It has provided valuable input to leadership based on employee expectations</li>
                </ul>
                <div className="content key-project-content">

                <Fancybox options={{Carousel: {infinite: false,},}}>
                  <div className="row case-study-row justify-content-center">
                    <div className="col-lg-6">
                      <div className="inner-card">
                        <div className="img-div"><img src={org_casestudy3_img1} alt="operationalService5" className="img" /></div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="inner-card">
                        <div className="img-div"><img src={org_casestudy3_img2} alt="operationalService6" className="img" /></div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="inner-card">
                        <div className="img-div"><img src={org_casestudy3_img3} alt="operationalService7" className="img" /></div>
                      </div>
                    </div>
                  </div>
                </Fancybox>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 04 */}
      <section className="case-study sec-padding">
        <div className="container">
          <SectionHeading secName="Case study" secText={<>Building Future-Ready Talent</>} />

          <div className="row case-study-row">
            <div className="col-lg-6">
              <div className="case-study-card">
                <h5 className="title">Project Stakeholders</h5>
                <ul className="content">
                  <li className="p-text">The client is a multi-product, multi-location manufacturing company</li>
                </ul>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="case-study-card">
                <h5 className="title">Project Scope</h5>
                <ul className="content">
                  <li className="p-text">Identify high-potential talent to support organizational growth and strengthen the leadership pipeline</li>
                  <li className="p-text">Help in segmentation of existing talent</li>
                  <li className="p-text">Provide inputs to the development agenda of the company based on assessment of talent</li>
                </ul>
              </div>
            </div>

            <div className="col-lg-12">
              <div className="case-study-card">
                <h5 className="title">Approach and Execution</h5>
                <ul className="content">
                  <li className="p-text">An intensive Development and Assessment Centres initiative was launched, covering over 1,800 employees</li>
                  <li className="p-text">Assessment tools were designed, and a set of 30 assessors trained</li>
                  <li className="p-text">The process extended to an entire cadre across functions and geographies</li>
                  <li className="p-text">The assessment process consisted of 72 Developmental Centres spread over four months</li>
                </ul>
              </div>
            </div>

            <div className="col-lg-12">
              <div className="case-study-card">
                <h5 className="title">Key Project Deliverables</h5>
                <ul className="content">
                  <li className="p-text"><b>Impact:</b> A comprehensive assessment report helped in talent segmentation, thereby facilitating the growth of top talent. The assessment also identified the future readiness of the talent. It provided the company with a roadmap for development based on the assessment analytics</li>
                </ul>
                <div className="content key-project-content">

                <Fancybox options={{Carousel: {infinite: false,},}}>
                  <div className="row case-study-row justify-content-center">
                    <div className="col-lg-6">
                      <div className="inner-card">
                        <div className="img-div"><img src={org_casestudy4_img1} alt="operationalService5" className="img" /></div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="inner-card">
                        <div className="img-div"><img src={org_casestudy4_img2} alt="operationalService6" className="img" /></div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="inner-card">
                        <div className="img-div"><img src={org_casestudy4_img3} alt="operationalService7" className="img" /></div>
                      </div>
                    </div>
                  </div>
                </Fancybox>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}